import getAPIDomain from '@signal/utils/env/apiDomain'
import { AUTH_POLICY } from './constants'

/**
 * This function returns an auth-related url with encoded base64 redirect URL
 * @param {string} path - the path segment (after https://apix.purecars.com/sheriff/external/v1/user) for this call
 * @param {string} extraQuery - additional query parameters to provide, if any
 * @param {string} redirectOverride - the redirect URL to use.  If not provided, the redirect is to the current window.location.href.
 * @return {string} - the URL to use for this auth call
 */
function getAuthUrlWithEncodedRedirect(
  path: string,
  extraQuery = '',
  redirectOverride = ''
): string {
  if (extraQuery) {
    extraQuery = `${extraQuery}&`
  }
  return `${getAPIDomain(
    '/sheriff/external'
  )}/v1/user/${path}/?${extraQuery}policy=${AUTH_POLICY}&redirect_encoded=${encodeURIComponent(
    btoa(redirectOverride || location.href)
  )}`
}

// public exports below this line

export const getLoginUrl = (extraQuery = '', redirectOverride = ''): string =>
  getAuthUrlWithEncodedRedirect('auth', extraQuery, redirectOverride)

export const getChangeTenantUrl = (tenantId: number): string =>
  getAuthUrlWithEncodedRedirect(`change_tenant/${tenantId}`)

export const getLogoutUrl = (redirectOverride: string): string =>
  getAuthUrlWithEncodedRedirect('logout', '', redirectOverride)

export const getImpersonationUrl = (email: string): string =>
  getAuthUrlWithEncodedRedirect(`impersonate/${email}`)

export const getUnimpersonationUrl = (): string =>
  getAuthUrlWithEncodedRedirect(`unimpersonate`)
